// Some insurer titles are stored with "&" escaped as "&amp;", e.g.
// "Koenig &amp; Bauer BKK". Vue escapes the text it renders, so they would
// show the entity literally. Only "&amp;" is decoded: other escaped
// characters such as "&lt;" stay escaped, so a title can't turn into markup.
export const decodeAmpersands = (text: string | undefined) =>
  text?.replace(/&amp;/g, '&')
